import { render, staticRenderFns } from "./EditKegBitTap.vue?vue&type=template&id=345a79a1&"
import script from "./EditKegBitTap.vue?vue&type=script&lang=js&"
export * from "./EditKegBitTap.vue?vue&type=script&lang=js&"
import style0 from "./EditKegBitTap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports